import { Button, CircularProgress, FormControl, Grid, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Search from "../../grnReceipts/Search";
import CachedIcon from '@material-ui/icons/Cached';
import moment from "moment";
import clsx from 'clsx';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllTask, fetchProjects } from "../../../../containers/actions/common/projectActions";
import EditIcon from '@material-ui/icons/Edit';
import { Pagination } from "@material-ui/lab";
import { ALL_PROJECT_TASKS } from "../../../../containers/actions/types";
import {  presentFormatedData } from "../../functionalComponents/dataFormatFunctions";
import PaginationInput from "../../models/pagination/PaginationInput";
import CustomButton from "../CusomButton";

const useStyles = makeStyles((theme) => ({

  refreshContainerSty:{display: 'flex', justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      paddingTop: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '1rem',
    },
  },
  refreshSty:{display: 'flex',alignItems: 'center',cursor: 'pointer','&:hover': {
    textDecoration: 'underline',
  }},
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  outlined: {
    padding: theme.spacing(1),
  },
  formControl: {
    minWidth: 120,
    fontSize: '0.875rem',
  },
  formPerPage: {
    minWidth: 60,
    fontSize: '0.875rem',
  },
  upload: {
    background:
      'transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;',
    color: 'white',
    textTransform: 'none',
    borderRadius: '2rem',
    // marginRight: 20,
    padding: '5px 20px',
    '&:hover': {
      backgroundColor: 'green',
      background: 'green',
      color: 'white',
    },
  },
  multipleLogo: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  clickableTextSty: {
    '&:hover': {
      textDecoration: 'underline',
    color: '#2196F3',
    cursor: 'pointer'
    },
  }
}))

const TasksDashboard = () => { 
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchQuery, searchQueryInput] = useState('');
  const [tempSearch, tempSearchQury] = useState('');
  const [noRowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState('')
  let loading = true;

  useEffect(() => {
    // Fetch projects from API
    dispatch({
      type: ALL_PROJECT_TASKS,
      payload: undefined
    })
    dispatch(fetchAllTask());
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch({
      type: ALL_PROJECT_TASKS,
      payload: undefined
    })
    setError('');
    loading = true;
    dispatch(fetchAllTask());
  }


  const handleSearchQuery = (event) => {
    let { value } = event.target;
    // if (value === '' || value === null) {
    //   tempSearchQury(value);
    //   searchQueryInput('');
    // } else {
    //   tempSearchQury(value);
    // }
  };

  const handleClearSearch = (event) => {
    event.preventDefault();
    tempSearchQury('');
    searchQueryInput('');
  };

  const submitSearch = (event) => {
    event.preventDefault();
    searchQueryInput(tempSearch.trim());
  };

  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };





  // Function to render projectStatus button with correct color based on projectStatus
  let rows = useSelector((state) => {
    if (state.pcmp.common.Projects?.allProjectsTasks?.status === true) {
      if (loading) {
        loading = false
      }
      return state.pcmp.common.Projects.allProjectsTasks.data.filter((val)=> val.status)
    } else if (state.pcmp.common.Projects?.allProjectsTasks?.status === false) {
      if (loading) {
        loading = false
      }
      if (error === '') {
      setError('Something went wrong. Please try again later.')
      }
      return [];
     }
    else {
      return [];
    }
  });
  
  let totalPages = Math.ceil(rows.length / noRowsPerPage);

  let records = currentPage * noRowsPerPage;

  const taskList = rows
  ? rows.slice(records - noRowsPerPage, records)
  : [];

let pages = rows
  ? Math.ceil(rows.length / noRowsPerPage)
  : null;

  let noPages = pages ? pages : 1;
  
  const renderprojectStatus = (projectStatus) => {
    let color;
    switch (projectStatus) {
      case 'Open':
        color = '#FFA500'; // bright orange
        break;
      case 'Closed':
        color = '#4CAF50'; // green
        break;
      case 'Delayed':
        color = '#A9A9A9'; // dark grey
        break;
      default:
        color = '#000';
    }
    return (
      <Typography variant='body1' style={{textAlign: 'center',
        padding: '0.25rem',
        borderRadius: '0.45rem',
        fontSize: '0.875rem',color: 'white',
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: 'nowrap',
        width:'100px'
      }}>
        {projectStatus}
        </Typography>
    );
  };

  return (
    <React.Fragment>
      <Grid container alignItems='center' style={{ paddingBottom: '0.5rem', paddingTop: '1rem' }} >
        <Grid item xs={12} sm={10} md={6}>
        <Typography variant='body2' style={{fontWeight: 500}}>
          Filter By:
        </Typography>
          <Search
            searchQuery={tempSearch}
            handleSearchQuery={handleSearchQuery}
            handleClearSearch={handleClearSearch}
            submitSearch={submitSearch}
            disabled={true}
            placeholder={'Search using Compound ID, Status, Actions'}
          />
          </Grid>
        <Grid item xs={12} md={6}>
          <Grid
            container
            className={classes.refreshContainerSty}
          >
            <Typography variant='caption' className={clsx(classes.padR20)}>
              {`Last synced @ ${moment(new Date()).format(
                'HH:mm:ss; DD MMMM, YYYY'
              )}`}
            </Typography>

            <Typography
              variant='caption'
              color='primary'
              className={classes.refreshSty}
              onClick = {handleRefresh}
            >
              Refresh
              <CachedIcon color='primary' style={{ fontSize: 15 }} />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justifyContent="flex-end" >
        <Grid item>
        <Typography variant='body2' className={classes.hgText}>
        PER PAGE
      </Typography>
      <FormControl className={classes.formPerPage}>
        <Select
          labelId='perpage-filter'
          id='perpage-filter-id'
          value={noRowsPerPage}
          variant='outlined'
          onChange={handleSetRows}
          classes={{
            outlined: classes.outlined,
          }}
        >
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={30}>30</MenuItem>
        </Select>
      </FormControl>
        </Grid>
      </Grid>
      <TableContainer component={Paper} style={{ marginTop: 20,maxHeight: 500 }}>
        <Table stickyHeader>
          <TableHead >
            <TableRow style={{ backgroundColor: "#F9F9FC" }}>
            <TableCell align="left" >Compound ID</TableCell>
                          <TableCell align="left" >Sponsor Name</TableCell>
                          {/* <TableCell align="left" >Deliverable Type</TableCell>
            <TableCell align="left" >Description of Deliverables</TableCell> */}
            <TableCell align="left" >Document Name</TableCell>
            <TableCell align="left" style={{whiteSpace:'nowrap'}} >Delivery Date</TableCell>
            <TableCell align="center" >Status</TableCell>
            <TableCell align="center" >Actions</TableCell>
          </TableRow>
          </TableHead>
          <TableBody>
          {loading === true && (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={8}>
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress color='primary' />
                      </div>
                    </TableCell>
                  </TableRow>
                      )}

            {loading === false && error === '' && (taskList.length > 0 ? taskList.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
              <TableRow >
              <TableCell align="left">{presentFormatedData(row.projectName)}</TableCell>
                        <TableCell align="left" >{presentFormatedData(row.sponsorOrgName)}</TableCell>
                        {/* <TableCell align="left" >{presentFormatedData(row.deliverableType)}</TableCell>
              <TableCell align="left" >{presentFormatedData(row.deliverableDescription)}</TableCell> */}
              <TableCell align="left" style={{ maxWidth: "500px" }} >{presentFormatedData(row.fileName)}</TableCell>
              <TableCell align="left" style={{whiteSpace:'nowrap'}} >{row?.deliveryDate ? moment(row.deliveryDate).format('DD-MMM-YYYY').toUpperCase():' - '}</TableCell>
              <TableCell align="center" style={{justifyItems:'center'}} >{renderprojectStatus(row.status)}</TableCell>
                        <TableCell align="center" style={{ width: "200px" }}>
                        {row.status === "Open" && row.enableApprovalFlag && (
                                <div style={{display:'flex'}}>
                                    <CustomButton
              hasBorder={true}
              style={{ marginLeft: "8px", whiteSpace:'nowrap' }} // Add margin to separate the buttons
                                    >
                                        Approve
            </CustomButton>
            <CustomButton
              hasBorder={true}
              style={{ marginLeft: "8px", whiteSpace:'nowrap' }} // Add margin to separate the buttons
                                    >
                      Reject
                    </CustomButton>
                  </div>
                )}
                {row.status === "Open" && row.requirementType==='Review' && (
                  <CustomButton
                  hasBorder={true}
                  style={{ marginLeft: "8px", whiteSpace:'nowrap' }} // Add margin to separate the buttons
                                        >
                    Mark review as complete
                  </CustomButton>
                )}
                {row.status === "Delayed" && (
                  <CustomButton
                  hasBorder={true}
                  style={{ marginLeft: "8px", whiteSpace:'nowrap' }} // Add margin to separate the buttons
                                        >
                    Send reminder
                  </CustomButton>
                )}
                        </TableCell>
                </TableRow>
                </React.Fragment>
            )): <TableRow>
            <TableCell
              colSpan={7}
              align='center'
            >
              No Records Found
            </TableCell>
            </TableRow>)}
            {loading === false && error !=='' && (<TableRow style={{border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0',}}><TableCell
              colSpan={7}
              align='center'
              
            >
              Something went wrong. Please try again later.
            </TableCell>
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>
      {taskList.length > 0 && <Grid
          container
          alignItems='center'
          justifyContent='center'
          style={{ paddingTop: '1rem' }}
        >
          {/* <Pagination
            page={currentPage}
            name='currentPage'
            onChange={(event, page) => handlePageChange(event, page)}
            count={noPages}
            variant='outlined'
            shape='rounded'
          /> */}
        <PaginationInput
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          page={currentPage}
        />
      </Grid>
      }
      

    </React.Fragment>
  );
};

export default TasksDashboard;
